import React, { useEffect, useState, useRef } from 'react';
import player1Image from '../../assets/images/player_1.png';
import player2Image from '../../assets/images/player_2.png';

function TimingOut() {
  const [timeLeft, setTimeLeft] = useState(100);
  const [isLeftPlayerFaded, setIsLeftPlayerFaded] = useState(false);
  const [isRightPlayerPulsing, setIsRightPlayerPulsing] = useState(false);
  const [showTrophy, setShowTrophy] = useState(false);

  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);
  const trophyTimeoutRef = useRef(null);

  useEffect(() => {
    const startAnimation = () => {
      // Reset all states
      setTimeLeft(100);
      setIsLeftPlayerFaded(false);
      setIsRightPlayerPulsing(false);
      setShowTrophy(false);

      // Clear any existing intervals/timeouts
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (trophyTimeoutRef.current) clearTimeout(trophyTimeoutRef.current);

      // Start the countdown
      intervalRef.current = setInterval(() => {
        setTimeLeft((prev) => {
          if (prev <= 0) {
            // Clear the countdown interval
            clearInterval(intervalRef.current);

            // Start the timeout sequence
            setIsLeftPlayerFaded(true);
            setIsRightPlayerPulsing(true);

            // Show trophy after pulse
            timeoutRef.current = setTimeout(() => {
              setShowTrophy(true);
              setIsRightPlayerPulsing(false);

              // Reset everything after showing trophy
              trophyTimeoutRef.current = setTimeout(() => {
                startAnimation();
              }, 2000);
            }, 500);

            return 0;
          }
          return prev - 1;
        });
      }, 30);
    };

    // Start the initial animation
    startAnimation();

    // Cleanup function
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      if (trophyTimeoutRef.current) clearTimeout(trophyTimeoutRef.current);
    };
  }, []); // Empty dependency array means this runs once on mount

  return (
    <div className="flex justify-center items-center space-x-8 mt-10 sm:mt-0">
      {/* Left Player */}
      <div className={`relative transition-opacity duration-500 ${isLeftPlayerFaded ? 'opacity-30' : 'opacity-100'}`}>
        <img src={player1Image} alt="Player 1" className="w-24 h-24 object-contain" />
        {/* Clock */}
        <div className="absolute -top-4 -right-4 w-12 h-12">
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#4B5563"
              strokeWidth="5"
            />
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="#FCD34D"
              strokeWidth="5"
              strokeDasharray={`${timeLeft * 2.83} 283`}
              transform="rotate(-90 50 50)"
            />
          </svg>
        </div>
      </div>

      {/* Right Player */}
      <div className={`relative transition-transform duration-500 ${isRightPlayerPulsing ? 'scale-110' : 'scale-100'}`}>
        <img src={player2Image} alt="Player 2" className="w-24 h-24 object-contain" />
        {/* Trophy */}
        <div className={`absolute -top-4 -right-4 w-12 h-12 transition-opacity duration-500 ${showTrophy ? 'opacity-100' : 'opacity-0'}`}>
          <svg viewBox="0 0 24 24" className="w-full h-full text-yellow-300">
            <path
              fill="currentColor"
              d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default TimingOut; 
